import * as tslib_1 from "tslib";
import { APP_BOOTSTRAP_LISTENER, APP_INITIALIZER, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { IconService } from '@services';
import CustomDateLocales from '@utils/custom-date-locales';
import { PageMetadataRegistry } from 'main/router';
import * as moment from 'moment';
export function initializer(appState, _iconService) {
    var _this = this;
    // Extend standard moment.js locales with custom settings.
    for (var _i = 0, _a = Object.keys(CustomDateLocales); _i < _a.length; _i++) {
        var locale = _a[_i];
        moment.updateLocale(locale, CustomDateLocales[locale]);
    }
    return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, appState.initialize().toPromise()];
                case 1:
                    _a.sent();
                    if (appState.authConfig.value.isTelemetryEnabled &&
                        !!window['mixpanel']) {
                        window['mixpanel'].init(appState.authConfig.value.mixpanelKey, { track_pageview: false });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    error_1.isSeed = true;
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
export var UIPATH_INITIALIZER = {
    provide: APP_INITIALIZER,
    useFactory: initializer,
    deps: [
        AppStateFacade,
        IconService,
    ],
    multi: true,
};
export function bootstrapListener(pageRegistry) {
    return function () {
        pageRegistry.listen();
    };
}
export var UIPATH_BOOTSTRAP_LISTENER = {
    provide: APP_BOOTSTRAP_LISTENER,
    useFactory: bootstrapListener,
    deps: [PageMetadataRegistry],
    multi: true,
};
